// extracted by mini-css-extract-plugin
export var arrow = "CookiesModal-module--arrow--2ea91";
export var arrowNo = "CookiesModal-module--arrow_no--78231";
export var arrowYes = "CookiesModal-module--arrow_yes--6a00c";
export var button = "CookiesModal-module--button--13b36";
export var container = "CookiesModal-module--container--1f45e";
export var flex = "CookiesModal-module--flex--1872b";
export var flex1 = "CookiesModal-module--flex_1--a6470";
export var flexCenter = "CookiesModal-module--flex_center--8d9bf";
export var flexCenterCol = "CookiesModal-module--flex_center_col--c9798";
export var flexCol = "CookiesModal-module--flex_col--43844";
export var flexFixCenterCol = "CookiesModal-module--flex_fix_center_col--e9e5d";
export var flexFixedCenterCol = "CookiesModal-module--flex_fixed_center_col--3fa46";
export var overlay = "CookiesModal-module--overlay--b9f91";
export var rotating = "CookiesModal-module--rotating--b0959";
export var text = "CookiesModal-module--text--af613";